import { IOfferResponseSchema } from '../../repositories/hidden-objects/entities/offer_hiding/OfferResponseSchema';
import {
  fetchHideOfferWebsite,
  THideOfferWebsiteRequest,
  THideOfferWebsiteResponse,
} from '../../repositories/hidden-objects/v1/hide-offer-website';
import { IApplicationContext } from '../../types/applicationContext';

export async function fetchHideOffer(context: IApplicationContext, parameters: THideOfferWebsiteRequest) {
  const { httpApi, logger } = context;

  try {
    const response: THideOfferWebsiteResponse = await fetchHideOfferWebsite({
      httpApi,
      parameters,
    });

    return response.response as IOfferResponseSchema;
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
